import { Typography } from '@sunwebgroup/ui-components/uds';
import { tok, space } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';

export const PartiallyHighlightedTextUds = ({
  text,
  query,
  className,
}: {
  text: string;
  query: string | null;
  className?: string;
}) => {
  let startIndex = -1;
  let endIndex = 0;

  if (query) {
    startIndex = text.toLowerCase().indexOf(query.toLowerCase());
    endIndex = startIndex + query.length;
  }

  return (
    <Wrapper className={className}>
      {startIndex === -1 && <Typography>{text}</Typography>}
      {startIndex >= 0 && (
        <>
          <Typography>{text.slice(0, startIndex)}</Typography>
          <HighlightedTextUds>{text.slice(startIndex, endIndex)}</HighlightedTextUds>
          <Typography>{text.slice(endIndex, text.length)}</Typography>
        </>
      )}
    </Wrapper>
  );
};

export const HighlightedTextUds = styled(Typography)`
  color: ${tok('primitives_color_red_500')};
`;

const Wrapper = styled.div`
  margin-right: ${space('primitives_space_8')};

  ${Typography} {
    margin: 0;
    padding: 0;
  }
`;
